import { useState, useEffect } from 'react';
import Typography, { type TypographyProps } from '@mui/material/Typography';

interface ElapsedTimerProps extends Omit<TypographyProps, 'children'> {
  startTime: string;
}

const formatElapsed = (startTime: string): string => {
  const diffMs = Date.now() - new Date(startTime).getTime();
  if (diffMs < 0) {
    return '00:00:00';
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':');
};

export const ElapsedTimer = ({ startTime, ...typographyProps }: ElapsedTimerProps) => {
  const [display, setDisplay] = useState(() => formatElapsed(startTime));

  useEffect(() => {
    setDisplay(formatElapsed(startTime));
    const interval = setInterval(() => {
      setDisplay(formatElapsed(startTime));
    }, 1000);
    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <Typography variant="h6" fontFamily="monospace" {...typographyProps}>
      {display}
    </Typography>
  );
};
